// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| EzClocker Logo UX CSS Classes
| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
.ezClockerLogo_32x32 {
  border: none;
  width: 32px;
  height: 32px;
}

.ezClockerLogoImgContaner_Center {
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: var(--ezClockerWhite);
  text-align: center;
}

.ezClockerLogoTextContaner_Center {
  padding: 10px;
  background-color: var(--ezClockerWhite);
  color: var(--ezBannerHeaderColor);
  text-align: center;
  font-size: var(--ezBannerHeaderFontSize);
  font-weight: var(--ezBannerHeaderFontWeight);
  font-style: var(--ezBannerHeaderFontStyle);
}

.ezClockerLogo_FullWidth {
  border: none;
  width: 85%;
  height: auto;
  text-align: center;
  vertical-align: middle;
}

.ezLogo-container-center {
  display: grid;
  padding: 4px;
  grid-template-columns: auto;
  grid-template-rows: auto;
  justify-content: center;
  align-content: center;
  background-color: var(--ezClockerWhite);
  color: var(--ezBannerHeaderColor);
  font-size: var(--ezBannerHeaderFontSize);
  font-weight: var(--ezBannerHeaderFontWeight);
  font-style: var(--ezBannerHeaderFontStyle);
  text-align: center;
  vertical-align: middle;
}

/* -------------------------------------------------------------------
| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 1023px) {
}
*/
/* -------------------------------------------------------------------
| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |
------------------------------------------------------------------- */
@media screen and (max-width: 768px) {
  .ezClockerLogo_FullWidth {
    border: none;
    width: 75%;
    height: auto;
  }
}
/* -------------------------------------------------------------------
| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |
------------------------------------------------------------------- */
@media screen and (max-width: 480px) {
  .ezClockerLogo_FullWidth {
    border: none;
    width: 75%;
    height: auto;
  }
}
/* -------------------------------------------------------------------
| Warable Screen Style  (https://yesviz.com/watches.php)            |
------------------------------------------------------------------- */
@media screen and (max-width: 319px) {
  .ezClockerLogo_FullWidth {
    border: none;
    width: 200px;
  }
  .ezLogo-container-center {
    padding: 0;
    background-color: var(--ezClockerWhite);
    color: var(--ezBannerHeaderColor);
    text-align: center;
    font-size: var(--ezBannerHeaderFontSize);
    font-weight: var(--ezBannerHeaderFontWeight);
    font-style: var(--ezBannerHeaderFontStyle);
  }
}`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-logo.css"],"names":[],"mappings":"AAAA;;;iEAAA;AAKA;EACI,YAAA;EACA,WAAA;EACA,YAAA;AAAJ;;AAGA;EACI,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uCAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,uCAAA;EACA,iCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4CAAA;EACA,0CAAA;AAAJ;;AAGA;EACI,YAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,YAAA;EACA,2BAAA;EACA,wBAAA;EACA,uBAAA;EACA,qBAAA;EACA,uCAAA;EACA,iCAAA;EACA,wCAAA;EACA,4CAAA;EACA,0CAAA;EACA,kBAAA;EACA,sBAAA;AAAJ;;AAIA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;EACI;IACI,YAAA;IACA,UAAA;IACA,YAAA;EAFN;AACF;AAMA;;qEAAA;AAGA;EACI;IACI,YAAA;IACA,UAAA;IACA,YAAA;EAJN;AACF;AAQA;;qEAAA;AAGA;EACI;IACI,YAAA;IACA,YAAA;EANN;EASE;IACI,UAAA;IACA,uCAAA;IACA,iCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4CAAA;IACA,0CAAA;EAPN;AACF","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| EzClocker Logo UX CSS Classes\r\n| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\n\r\n.ezClockerLogo_32x32 {\r\n    border: none;\r\n    width: 32px;\r\n    height: 32px;\r\n}\r\n\r\n.ezClockerLogoImgContaner_Center {\r\n    padding-top: 10px;\r\n    padding-left: 10px;\r\n    padding-right: 10px;\r\n    background-color: var(--ezClockerWhite);\r\n    text-align: center;\r\n}\r\n\r\n.ezClockerLogoTextContaner_Center {\r\n    padding: 10px;\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezBannerHeaderColor);\r\n    text-align: center;\r\n    font-size: var(--ezBannerHeaderFontSize);\r\n    font-weight: var(--ezBannerHeaderFontWeight);\r\n    font-style: var(--ezBannerHeaderFontStyle);\r\n}\r\n\r\n.ezClockerLogo_FullWidth {\r\n    border: none;\r\n    width: 85%;\r\n    height: auto;\r\n    text-align: center;\r\n    vertical-align: middle;\r\n}\r\n\r\n.ezLogo-container-center {\r\n    display: grid;\r\n    padding: 4px;\r\n    grid-template-columns: auto;\r\n    grid-template-rows: auto;\r\n    justify-content: center;\r\n    align-content: center;\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezBannerHeaderColor);\r\n    font-size: var(--ezBannerHeaderFontSize);\r\n    font-weight: var(--ezBannerHeaderFontWeight);\r\n    font-style: var(--ezBannerHeaderFontStyle);\r\n    text-align: center;\r\n    vertical-align: middle;\r\n}\r\n\r\n\r\n/* -------------------------------------------------------------------\r\n| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 1023px) {\r\n}\r\n*/\r\n\r\n/* -------------------------------------------------------------------\r\n| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |\r\n------------------------------------------------------------------- */\r\n@media screen and (max-width: 768px) {\r\n    .ezClockerLogo_FullWidth {\r\n        border: none;\r\n        width: 75%;\r\n        height: auto;\r\n    }\r\n}\r\n\r\n\r\n/* -------------------------------------------------------------------\r\n| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |\r\n------------------------------------------------------------------- */\r\n@media screen and (max-width: 480px) {\r\n    .ezClockerLogo_FullWidth {\r\n        border: none;\r\n        width: 75%;\r\n        height: auto;\r\n    }\r\n}\r\n\r\n\r\n/* -------------------------------------------------------------------\r\n| Warable Screen Style  (https://yesviz.com/watches.php)            |\r\n------------------------------------------------------------------- */\r\n@media screen and (max-width: 319px) {\r\n    .ezClockerLogo_FullWidth {\r\n        border: none;\r\n        width: 200px;\r\n    }\r\n\r\n    .ezLogo-container-center {\r\n        padding: 0;\r\n        background-color: var(--ezClockerWhite);\r\n        color: var(--ezBannerHeaderColor);\r\n        text-align: center;\r\n        font-size: var(--ezBannerHeaderFontSize);\r\n        font-weight: var(--ezBannerHeaderFontWeight);\r\n        font-style: var(--ezBannerHeaderFontStyle);\r\n    }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
